<script>


import {balance, createInvoice, getInvoiceDetails, topUp} from "@/api/subscriptions";
import {search} from "@/api/organizations";


import * as organizationApi from '@/api/organizations';
import {mapActions, mapGetters} from "vuex";
import moment from "moment";

export default {
  name: 'SubscriptionBalance',
  data() {
    this.load()
    return {
      query: '',

      amount: 0,

      balance: 0,

      makePayment: false,
      createInvoice: false,
      withdraw: true,
      income_source: 'card',
      requisites: {},
      offers: [],
      need_search: false,
      formHasErrors: false,
      not_search: false,
      validates: {
        client_inn: true,
        client_bik: true,
        client_name: true,
        client_rs: true,
        client_ks: true,
        client_bank_name: true,
        client_legal_address: true,
      },
      invoice: {
        product_name: 'Пополнение баланса',
        client_inn: '',
        client_bik: '',
        client_name: '',
        client_rs: '',
        client_ks: '',
        client_bank_name: '',
        client_legal_address: '',
        user_subscription_id: 0
      },
    }
  },

  mounted() {
    this.load();
  },

  computed: {
    ...mapGetters('subscription', [
      'isChecked',
      'isModalVisible',
      'getBusySlots',
      'getSlots',
      'getItemSlots',
      'isSlotPresented',
      'getStep',
      'getItems',
      'getState',
      'getServices',
      'getItemSlotsList',
      'getDiscount'
    ]),
    ...mapGetters('user', ['USER_ID']),
    ...mapGetters('workspace', ['ID_WORK_SPACE']),
    userBalance() {
      return this.balance
    },
    serviceNum() {
      return this.services.filter(service => this.isChecked(service.id)).length;
    }
    ,
    getSum() {
      return parseInt(this.amount)
    },
    getTotalSum() {
      return this.amount
    }
  }
  ,
  methods: {
    ...mapActions('subscription', ['setSlots', 'hideModal', 'showModal', 'toggleItemSlot', 'setDiscounts', 'setStep', 'toggleService']),
    searchByInn() {
      search({'inn': this.invoice.client_inn})
          .then(
              (json) => {
                this.invoice.client_name = ''
                this.invoice.client_legal_address = ''
                this.invoice.client_bik = ''
                this.invoice.client_rs = ''
                this.invoice.client_ks = ''
                this.invoice.client_bank_name = ''
                if (Object.keys(json.data).length !== 0) {
                  this.invoice.client_name = json.data.fullName
                  this.invoice.client_legal_address = json.data.address
                  this.invoice.client_bik = ''
                  this.invoice.client_rs = ''
                  this.invoice.client_ks = ''
                  this.invoice.client_bank_name = ''
                }
              }
          )
    },
    fill(offer) {
      this.not_search = true
      this.invoice.client_name = offer.name
      this.invoice.client_legal_address = offer.address
      this.invoice.client_inn = offer.inn
      this.invoice.client_bik = offer.bik
      this.invoice.client_rs = offer.checking_account
      this.invoice.client_ks = offer.corr_account
      this.invoice.client_bank_name = offer.bank_name
      this.offers = []
      this.need_search = false
      this.validates = {
        client_inn: true,
        client_bik: true,
        client_name: true,
        client_rs: true,
        client_ks: true,
        client_bank_name: true,
        client_legal_address: true,
      }
    },
    searchInvoiceDetails() {
      this.offers = []
      this.need_search = true
      this.requisites.filter(
          (req) => {
            if (this.need_search && req.inn.startsWith(this.invoice.client_inn)) {
              this.offers.push(req)
            }
          }
      )
      if (this.offers.length === 0) {
        this.not_search = false
      }
    },
    async load() {
      let response = await organizationApi.workspaceOrganizations(this.ID_WORK_SPACE);
      this.organizations = response.data.data.map(
          (item) => {
            return {
              id: item.id,
              name: item.short_name,
              inn: item.inn
            }
          }
      )

      await balance().then(
          (json) => {
            this.balance = json.data.balance
          }
      )

      await getInvoiceDetails().then(
          (json) => {
            this.requisites = json.data
            this.offers = json.data
          }
      )
    },
    getFinishDate(service) {
      const duration = this.getItemSlotsList(service.id).duration
      return moment().add(duration, 'M')
    },
    getStartDate() {
      return moment()
    },
    async createSubscription() {
      return 1
    },

    validate(name) {
      if (name === 'client_inn' && !this.not_search) {
        this.searchByInn()
      }
      if (this.$refs[name].validate()) {
        this.validates[name] = true
      } else {
        this.validates[name] = false
      }
    },

    payWithCard() {

      const data = {
        source: 'card',
        amount: this.amount,
        services: []
      };
      topUp(data.amount, this.USER_ID, data.services).then(
          (response) => {
            // console.log(response)
            window.location = response.data.url
          }
      )

    },

    getInvoice() {
      this.formHasErrors = false
      console.log('Ok');
      Object.keys(this.invoice).forEach(f => {
        if (f && !this.invoice[f] && f !== 'discount' && f !== 'user_subscription_id') {
          console.log(f, this.invoice[f])
          console.log(f, true)
          this.formHasErrors = true
        }
        if (this.$refs[f]) {
          this.$refs[f].validate(true)
          if (!this.$refs[f].validate()) {
            this.validates[f] = false
            this.formHasErrors = true
            console.log(f, this.validates[f])
          } else {
            this.validates[f] = true
          }
        }
      })
      console.log(this.formHasErrors)
      if (!this.formHasErrors) {
        this.createInvoice = true
        console.log('step 3')
        createInvoice(
            this.invoice,
            parseInt(this.getSum),
            this.USER_ID
        ).then((response) => {
          console.log('step 4')
          this.$router.push({name: 'SubscriptionDownloadInvoice', params: {id: response.data.id}})
        })
      }
    },
  }
}
</script>


<template>
  <div>
    <div class="awaiting" v-if="createInvoice">
      <p>Выписываем счет по указанным реквизитам.</p>
    </div>
    <div class="ais24--subscription">
      <div class="ais24--container">
        <div class="ais24--rate-grid" v-if="!makePayment">
          <div class="ais24--rate-grid__content">
            <div class="ais24--rate-payment ais24--rate-balance__fieldset">
              <fieldset class="ais24--fieldset">
                <div class="ais24--field-checkbox__caption ais24--balance_text">На балансе: {{ userBalance }} ₽</div>
              </fieldset>
              <fieldset class="ais24--fieldset">
                <button class="ais24--button ais24--button--primary" @click="makePayment = true">Пополнить баланс
                </button>
              </fieldset>
            </div>
          </div>
        </div>
        <template v-else>
          <header class="ais24--header">
            <h2 class="ais24--title">Пополнение баланса</h2>
          </header><!--/.ais24--header-->
          <div class="ais24--details">
            <div class="ais24--details__content">
              <div class="ais24--payment ais24--selected-subscriptions-card">
                <fieldset class="ais24--fieldset">
                  <legend class="ais24--fieldset__legend">Выберите способ оплаты</legend>
                  <div class="ais24--fieldset__inner">
                    <div class="ais24--field-radio-group ais24--field-radio-group--vertical">
                      <div class="ais24--field-radio">
                        <label class="ais24--field-radio__label">
                          <input class="ais24--field-radio__input" type="radio" name="payment-method"
                                 v-model="income_source"
                                 value="card">
                          <span class="ais24--field-radio__caption">Банковской картой</span>
                        </label>
                      </div>
                      <div class="ais24--field-radio">
                        <label class="ais24--field-radio__label">
                          <input class="ais24--field-radio__input" type="radio" name="payment-method"
                                 v-model="income_source"
                                 value="bank">
                          <span class="ais24--field-radio__caption">Безналичная оплата</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </fieldset>
                <template v-if="income_source === 'bank'">
                  <fieldset class="ais24--fieldset">
                    <legend class="ais24--fieldset__legend">Введите реквизиты</legend>

                    <div class="ais24--fieldset__inner">
                      <div class="ais24--field-number">

                        <label class="ais24--field-number__label">ИНН</label>
                        <v-text-field
                            ref="client_inn"
                            required
                            :rules="[v => !!v || 'Поле обязательно к заполнению']"
                            flat
                            solo
                            class="ais24--field-number__input"
                            :hide-details="validates.client_inn"
                            hide-spin-buttons
                            single-line
                            variant="plain"
                            label="Введите ИНН"
                            v-model="invoice.client_inn"
                            @blur="validate('client_inn')"
                            @keyup="searchInvoiceDetails"
                        >
                        </v-text-field>

                      </div>
                      <div v-if="requisites.length" class="requisites">
                        <label class="ais24--field-number__label">Вы ранее использовали следующие реквизиты, можете
                          выбрать
                          из них:</label>
                        <span v-for="offer in offers" v-bind:key="offer.id" class="requisite" @click="fill(offer)">
                      {{ offer.name }}<br/>
                      ИНН: {{ offer.inn }}<br/>
                      Наименование банка: {{ offer.bank_name }}, счет: {{ offer.checking_account }}
                    </span>
                      </div>

                      <div class="ais24--field-text">
                        <label class="ais24--field-text__label">Наименование юридического лица</label>

                        <v-text-field
                            ref="client_name"
                            required
                            :rules="[v => !!v || 'Поле обязательно к заполнению']"
                            flat
                            solo
                            class="ais24--field-number__input"
                            :hide-details="validates.client_name"
                            hide-spin-buttons
                            single-line
                            variant="plain"
                            v-model="invoice.client_name"
                            @blur="validate('client_name')"
                        ></v-text-field>
                      </div>
                      <div class="ais24--field-number">
                        <label class="ais24--field-number__label">Наименование банка</label>
                        <v-text-field
                            ref="client_bank_name"
                            required
                            :rules="[v => !!v || 'Поле обязательно к заполнению']"
                            flat
                            solo
                            class="ais24--field-number__input"
                            :hide-details="validates.client_bank_name"
                            hide-spin-buttons
                            single-line
                            variant="plain"
                            v-model="invoice.client_bank_name"
                            @blur="validate('client_bank_name')"
                        ></v-text-field>
                      </div>
                      <div class="ais24--field-number">
                        <label class="ais24--field-number__label">БИК</label>
                        <v-text-field
                            ref="client_bik"
                            required
                            :rules="[v => !!v || 'Поле обязательно к заполнению']"
                            flat
                            solo
                            class="ais24--field-number__input"
                            :hide-details="validates.client_bik"
                            hide-spin-buttons
                            single-line
                            variant="plain"
                            v-model="invoice.client_bik"
                            @blur="validate('client_bik')"
                        ></v-text-field>
                      </div>
                      <div class="ais24--field-number">
                        <label class="ais24--field-number__label">Корр. счёт</label>
                        <v-text-field
                            required
                            ref="client_ks"
                            :rules="[v => !!v || 'Поле обязательно к заполнению']"
                            flat
                            solo
                            class="ais24--field-number__input"
                            :hide-details="validates.client_ks"
                            hide-spin-buttons
                            single-line
                            variant="plain"
                            v-model="invoice.client_ks"
                            @blur="validate('client_ks')"
                        ></v-text-field>
                      </div>
                      <div class="ais24--field-number">
                        <label class="ais24--field-number__label">Расчётный счёт</label>
                        <v-text-field
                            required
                            ref="client_rs"
                            :rules="[v => !!v || 'Поле обязательно к заполнению']"
                            flat
                            solo
                            class="ais24--field-number__input"
                            :hide-details="validates.client_rs"
                            hide-spin-buttons
                            single-line
                            variant="plain"
                            v-model="invoice.client_rs"
                            @blur="validate('client_rs')"
                        ></v-text-field>
                      </div>
                      <div class="ais24--field-number">
                        <label class="ais24--field-number__label">Адрес</label>
                        <v-text-field
                            required
                            ref="client_legal_address"
                            :rules="[v => !!v || 'Поле обязательно к заполнению']"
                            flat
                            solo
                            class="ais24--field-number__input"
                            :hide-details="validates.client_legal_address"
                            hide-spin-buttons
                            single-line
                            variant="plain"
                            v-model="invoice.client_legal_address"
                            @blur="validate('client_legal_address')"
                        ></v-text-field>
                      </div>
                    </div>
                  </fieldset>
                  <fieldset class="ais24--fieldset">
                    <div class="ais24--fieldset__inner">
                      <div class="ais24--field-checkbox ais24--field-checkbox--default">
                        <label class="ais24--field-checkbox__label">
                          <input class="ais24--field-checkbox__input" type="checkbox" checked>
                          <div class="ais24--field-checkbox__title">
                            <div class="ais24--field-checkbox__caption">Запомнить данные для дальнейших оплат</div>
                          </div>
                        </label>
                      </div>
                    </div>
                  </fieldset>
                </template>
                <template v-else>
                  <fieldset class="ais24--fieldset">
                    <!-- CARD -->
                  </fieldset>
                </template>

                <fieldset class="ais24--fieldset">
                  <legend class="ais24--fieldset__legend">Введите сумму пополнения</legend>
                  <div class="ais24--fieldset__inner">
                    <div class="ais24--field-radio-group ais24--field-radio-group--vertical">
                      <div class="ais24--field-radio">
                        <label class="ais24--field-radio__label">
                          <input class="ais24--field-text__input" type="number" name="payment-amount"
                                 v-model="amount" min="0">
                        </label>
                      </div>
                    </div>
                  </div>
                </fieldset>

              </div><!--/.ais24--payment-->
            </div><!--/.ais24--details__content-->
            <aside class="ais24--details__sidebar">
              <div class="ais24--calculation">
                <header class="ais24--calculation-header">
                  <h3 class="ais24--calculation-header__title">Пополнение баланса</h3>
                </header><!--/.ais24--calculation-header-->
                <footer class="ais24--calculation-footer">
                  <div class="ais24--calculation-total">
                    <div class="ais24--calculation-total__text">Итого:</div>
                    <div class="ais24--calculation-total__price">{{ getSum }}&nbsp;₽</div>
                  </div><!--/.ais24--calculation-total-->
                  <div class="ais24-calculation-action">
                    <button class="ais24--button ais24--button--primary ais24--button--large" type="button"
                            :disabled="getSum === 0"
                            v-if="income_source === 'bank'" @click="getInvoice">
                      <span class="ais24--button__text">Выставить счёт</span>
                    </button>
                    <button class="ais24--button ais24--button--primary ais24--button--large" type="button"
                            :disabled="getSum === 0"
                            v-if="income_source === 'card'" @click="payWithCard">
                      <span class="ais24--button__text">Перейти к оплате</span>
                    </button>
                  </div><!--/.ais24-calculation-action-->
                </footer><!--/.ais24--calculation-footer-->
              </div><!--/.ais24--calculation-->
            </aside><!--/.ais24--details__sidebar-->
          </div>
        </template>
      </div><!--/.ais24--container-->
    </div>
  </div>

</template>

<style scoped lang="scss">
.ais24--dialog .ais24--dialog-body {
  flex: auto;
}
</style>
